<template>
<div class="records-list">
  <em v-if="meta && meta.total_pages == 1" class="records-count-summary">
    Showing all {{meta.total_results}} records.
  </em>
  <em v-else-if="meta && meta.total_pages > 1" class="records-count-summary">
    Showing {{meta.per_page}} of {{meta.total_results}} records.
  </em>
  <div class="table-responsive">
    <table class="border--round table--alternate-row">
      <thead>
        <tr>
          <th class="oc-number d-print-none" v-show="!hideID">OC#</th>
          <th class="taxa" v-show="!hideTaxa">Taxa</th>
          <th class="user" v-show="!hideUser">User</th>
          <th class="location" v-show="!hideLocation">Location</th>
          <th class="observed" v-show="!hideObserved">Observed</th>
          <th class="status" v-show="!hideStatus">Status</th>
          <th class="vetted-on" v-show="!hideVetted">Vetted On</th>
          <th class="count d-none d-print-table-cell">Count</th>
          <th v-if="lifeStages" class="life-stage d-none d-print-table-cell">Life Stage</th>
          <th class="oc-number visible-print" v-show="!hideID">OC#</th>
          <th class="details d-print-none" v-show="!hideDetails"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sighting in value" :key="sighting.id">
          <td class="oc-number d-print-none" v-show="!hideID">{{sighting.id}}</td>
          <td class="taxa notranslate" translate="no" v-show="!hideTaxa">{{sighting.taxon_data.common_name}}&nbsp;<br class="d-print-none" /><em>({{sighting.taxon_data.scientific_name}})</em></td>
          <td class="user" v-show="!hideUser">
            <template v-if="sighting.user_data">
              <router-link :to="{ name: 'profile', params: { id: sighting.user_data.id }}">
                {{sighting.user_data.display_name}}
              </router-link>
            </template>
          </td>
          <td class="location notranslate" v-show="!hideLocation" translate="no">
            <div v-if="sighting.jurisdiction_data">
              {{sighting.jurisdiction_data.display_name}}
            </div>
            ({{sighting.location_data.latitude}},{{sighting.location_data.longitude}})
          </td>
          <td class="observed" v-show="!hideObserved">
            <span v-if="sighting.checklist_data.datetime">{{ sighting.checklist_data.datetime.split('T')[0] | moment(momentDisplayFormat()) }}</span>
          </td>
          <td class="status" v-show="!hideStatus">
            <template v-if="sighting.status_data">
              {{sighting.status_data.name}}
            </template>
          </td>
          <td class="vetted-on" v-show="!hideVetted">
            <span v-if="sighting.vetted_datetime">{{ sighting.vetted_datetime | moment(momentDisplayFormat()) }}</span>
            <span v-else>N/A</span>
          </td>
          <td class="count d-none d-print-table-cell">{{sighting.count}}</td>
          <td v-if="lifeStages" class="life-stage d-none d-print-table-cell">
            {{ getLifeStage(sighting.life_stage) }}
          </td>
          <td class="oc-number visible-print" v-show="!hideID">{{sighting.id}}</td>
          <td class="details d-print-none" v-show="!hideDetails">
            <a href="javascript:void(0)" class="btn btn-default btn--xs" v-on:click="$refs.recordsSightingModal.showSighting(sighting.id)">details</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <sighting-modal 
    uniqueID="recordsSightingID" 
    ref="recordsSightingModal" 
    @sightingChanged="sightingChanged"
    >
    </sighting-modal>
</div>

  
  
</template>

<script>
  export default {
    name: 'RecordsList',
    props: ['value', 'hideID', 'hideTaxa', 'hideUser', 'hideLocation', 'hideObserved', 'hideStatus', 'hideVetted', 'hideDetails', 'meta', 'lifeStages'],
    data: function(){
      return {
        current_sighting_id:null,
      };
    },
    methods:{
      sightingChanged:function(id){
        this.current_sighting_id = id;
      },
      getNextSightingID:function(){
        return null;
      },
      getPreviousSightingID:function(){
        return null;
      },
      getPreviousSightingExists:function(){
        return false;
      },
      getNextSightingExists:function(){
        return false;
      },
      getLifeStage:function(life_stage_id){
        if (!this.lifeStages) {
          return;
        }
        var ls = this.lifeStages.find(l => l.id == life_stage_id);
        if (ls) {
          return ls.name;
        }
        return;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/RecordsList.vue